
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { AuthEnum } from '@/services/permission.service';

declare const AMap: any;

@Component
export default class LookVirtualPoi extends Vue {
  map: any;

  radius = 5;

  AuthEnum = AuthEnum;

  changeRadius = false;

  radiusrange: any = 5000;

  @Prop()
  region!: string;

  @Prop()
  shopId!: string;

  @Prop()
  PoiList!: any;

  @Prop()
  editType!: string;

  @lazyInject(ShopService)
  shopService!: ShopService;

  visible = false;

  geocoder: any = null;
  // 🔥 新增：存储点位和覆盖物
  markers: any[] = [];
  circles: any[] = [];
  points: Array<{ lng: number; lat: number; address: string }> = [];

  poiPoints: any[] = [];

  districtBoundaries: any[] = [];


  init(radius: any) {
    if (radius) {
      this.radius = radius / 1000;
      this.radiusrange = radius;
    }
    if (!this.region) {
      this.$message.error('区域地址为空');
      return;
    }
    this.visible = true;
    this.$nextTick(() => {
      const region = this.region.split('/')[1];
      this.initMap(region);
    });
  }

  changeType() {
    this.changeRadius = !this.changeRadius;
  }

  deleteItem(index: any) {
    this.points.splice(index, 1);
    this.funRedrawMarker();
  }

  funRedrawMarker() {
    // console.log('重新绘制标记');
    this.map.remove(this.markers);
    this.map.remove(this.circles);
    this.markers = [];
    this.circles = [];
    this.points.forEach((res) => {
      const { lng, lat, address } = res;
      // ✅ 创建 Marker
      const marker = new AMap.Marker({
        position: [lng, lat],
        title: address,
        icon: new AMap.Icon({
          image: require('../../../assets/icon_pos.png'),
          size: new AMap.Size(52, 52), // 图标大小
          imageSize: new AMap.Size(30, 30),
          anchor: 'bottom-center',

        }),
        offset: new AMap.Pixel(-15, -30),
        label: {
          content: address,
          // offset: new AMap.Pixel(0, -30),
          direction: 'top',
          style: {
            // backgroundColor: '#1890FF',
            color: '#fff',
            // borderColor: '#1890FF',
            borderRadius: '4px',
            padding: '4px 8px',
            fontSize: '10px',
            fontWeight: 'bold',
            whiteSpace: 'normal',
            maxWidth: '50px',
            display: 'block',
            // whiteSpace: 'nowrap'
          },
        },
      });

      // ✅ 创建 5000 米半径的圆形覆盖物
      const circle = new AMap.Circle({
        center: [lng, lat],
        radius: this.radiusrange,
        strokeColor: '#3366FF',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#3366FF',
        fillOpacity: 0.25,

        zIndex: 10,
      });
      // circle.on('click', this.handleMapClick);


      // 🔼 添加到地图
      this.map.add(marker);
      this.map.add(circle);
      // console.log('markers 长度:', this.markers);
      // 🔼 存入队列（先进先出）
      this.markers.push(marker);
      this.circles.push(circle);
    });
  }

  onChange(value: any) {
    // console.log('changed', value);
    if (value < 1) {
      this.$message.error('半径不能小于1公里');
      return;
    }
    this.radiusrange = value * 1000;
    this.funRedrawMarker();
  }

  initMap(region: any) {
    this.map = new AMap.Map('map', {
      zoom: 11,
      center: [116.397428, 39.90923],
    });
    this.map.addControl(new AMap.ToolBar());
    // this.map.on('click', this.handleMapClick);
    this.geocoder = new AMap.Geocoder();
    this.highlightDistrict(region);
  }

  highlightDistrict(districtName: any) {
    // 创建行政区查询实例
    const districtSearch = new AMap.DistrictSearch({
      level: 'city', // 查询级别，可选：country, province, city, district
      extensions: 'all', // 返回边界坐标
    });
    // console.log('districtName', districtName);

    districtSearch.search(districtName, (status: string, result: any) => {
      // console.log(status, result);
      if (status === 'complete' && result.districtList?.length) {
        const bounds = result.districtList[0].boundaries;
        if (bounds && bounds.length > 0) {
          this.districtBoundaries = bounds;
          // 绘制多边形覆盖物
          const districtPolygon = new AMap.Polyline({
            path: bounds,
            strokeColor: '#f00',
            strokeWeight: 5,
            strokeOpacity: 1,
            lineCap: 'round',
            lineJoin: 'round',
            zIndex: 10,
          });
          this.map.add(districtPolygon);
          // 自动缩放视野到该区域
          this.map.setFitView(districtPolygon);
          this.PoiList.forEach((res: any) => {
            this.addPoint(res.longitude, res.latitude, res.address);
          });
        } else {
          console.warn('该区域无边界数据');
        }
      } else {
        console.error('行政区查询失败:', result);
      }
    });
  }

  addPoint(lng: number, lat: number, address: string) {
    // console.log('添加点位', lng, lat, address, poiName);
    // console.log('markers 长度:', this.markers);
    // if (this.markers.length >= 3) {
    //   return;
    // }

    // ✅ 创建 Marker
    const marker = new AMap.Marker({
      position: [lng, lat],
      title: address,
      icon: new AMap.Icon({
        image: require('../../../assets/icon_pos.png'),
        size: new AMap.Size(52, 52), // 图标大小
        imageSize: new AMap.Size(30, 30),
        anchor: 'bottom-center',

      }),
      offset: new AMap.Pixel(-15, -30),
      label: {
        content: address,
        // offset: new AMap.Pixel(0, -30),
        direction: 'top',
        style: {
          // backgroundColor: '#1890FF',
          color: '#fff',
          // borderColor: '#1890FF',
          borderRadius: '4px',
          padding: '4px 8px',
          fontSize: '10px',
          fontWeight: 'bold',
          whiteSpace: 'normal',
          maxWidth: '50px',
          display: 'block',
          // whiteSpace: 'nowrap'// 防止换行
        },
      },
    });

    // ✅ 创建 5000 米半径的圆形覆盖物
    const circle = new AMap.Circle({
      center: [lng, lat],
      radius: this.radiusrange,
      strokeColor: '#3366FF',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#3366FF',
      fillOpacity: 0.25,

      zIndex: 10,
    });
    // circle.on('click', this.handleMapClick);

    // 🔼 添加到地图
    this.map.add(marker);
    this.map.add(circle);
    // console.log('markers 长度:', this.markers);
    // 🔼 存入队列（先进先出）
    this.markers.push(marker);
    this.circles.push(circle);
    this.points.push({ lng, lat, address });

    // 🔼 更新提示信息
    // 可选：自动缩放到该点
    // this.map.setCenter([lng, lat]);
  }

  handleMapClick(e: any) {
    const { lnglat } = e;
    // const { lng, lat } = lnglat;

    // if (this.markers.length >= 3) {
    //   this.$message.error('最多添加3个点位，请删除后再添加新点位');
    //   return;
    // }
    // 调试信息
    // console.log('boundaries 长度:', this.districtBoundaries.length);

    if (this.districtBoundaries.length === 0) {
      // this.clickInfo = '❌ 行政区边界数据未加载，请稍等或更换区域';

      return;
    }
    let isInDistrict = false;
    for (const ring of this.districtBoundaries) {
      if (!Array.isArray(ring) || ring.length < 3) continue;

      try {
        // 判断点是否在任意一个环内
        if (AMap.GeometryUtil.isPointInRing(lnglat, ring)) {
          isInDistrict = true;
          break;
        }
      } catch (err) {
        console.warn('isPointInRing 出错:', err);
      }
    }

    if (!isInDistrict) {
      this.$message.error('请在指定区域内点击');
      return;
    }

    // ✅ 在区域内，继续解析地址
    this.geocoder.getAddress(lnglat, (status: string, result: any) => {
      if (status === 'complete' && result.regeocode) {
        const address = result.regeocode.formattedAddress;
        // const poiName = result.regeocode.poiList?.pois[0]?.name || '未知地点';
        // console.log('poiName:', poiName);
        this.addPoint(lnglat.lng, lnglat.lat, address);
      } else {
        // this.clickInfo = `✅ 位置有效，但地址解析失败: ${lng}, ${lat}`;
      }
    });
  }

  async handleSubmit() {
    const point = {
      point: this.points.map((res: any) => { return { longitude: res.lng, latitude: res.lat, radius: this.radiusrange }; }),
      radius: this.radiusrange,
    };
    if (this.editType === '2') {
      this.$emit('editPoiType', point);
      this.close();
      return;
    }
    const res = await this.shopService.postPointEdit(this.shopId, point);
    if (res) {
      this.$message.success('点位更新成功');
      this.close();
      this.$emit('refresh');
    }
  }

  close() {
    this.visible = false;
    this.markers = [];
    this.circles = [];
    this.points = [];
    this.districtBoundaries = [];
    this.map.clearMap();
    this.changeRadius = false;
  }
}
